import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const SECTIONS = [
  { title: '用户', desc: '查看用户席位、IP、算力余额和最近消耗明细', to: '/users' },
  { title: '席位', desc: '审批席位申请、手动下发席位、调整单席位算力', to: '/seats' },
  { title: '模型路由', desc: '按 user / plan / 全局改写客户端请求的 model，5 min 内生效', to: '/routes' },
  { title: '审计日志', desc: '每一次 admin 写操作的完整参数 + 结果 + 耗时', to: '/logs' },
];

export function DashboardPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold tracking-tight">概览</h2>
        <p className="text-muted-foreground mt-1">从侧边栏进入任一模块。所有写操作会自动记录到审计日志。</p>
      </div>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {SECTIONS.map((s) => (
          <Card key={s.to}>
            <CardHeader>
              <CardTitle>{s.title}</CardTitle>
              <CardDescription>{s.desc}</CardDescription>
            </CardHeader>
            <CardContent>
              <a href={s.to} className="text-sm underline underline-offset-4 hover:text-foreground">
                进入 →
              </a>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
